module.exports = __webpack_public_path__ + "static/media/nikon_mock.4c54fc25.png";